import { useState, useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import { InfoWrapper } from "pages/protectedPages/ActivityLog/styles";
import { SettingsWrapper } from "pages/protectedPages/Configuration/styles";
import { MainFooter } from "components/layouts/main/MainFooter";
import { Col, Row, Image } from "antd";
import { LogoIcon } from "config/IconConfig";
import {
  LayoutMain,
  LayoutMaster,
} from "components/layouts/main/MainLayout/styles";
import apiService from "services/apiservice";
import { getErrorMessageString } from "utils/utils";
import { notificationController } from "components/common/notificationController";
import RejectedReasons from "./RejectedReasons";

export const TenderPageAcceptance = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState("");
  const [tenderId, setTenderId] = useState<any>();
  const [housebill, setHousebill] = useState<any>();
  const [showRejectedReasons, setShowRejectedReasons] = useState<any>();
  const initialized = useRef(false);

  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;
      const statusParam = searchParams.get("status");
      setStatus(statusParam || "accepted");
      const tenderIdParam = searchParams.get("tenderId");
      setTenderId(tenderIdParam || null);
      const housebillParam = searchParams.get("housebill");
      setHousebill(housebillParam || null);
    }
  }, [searchParams]);

  useEffect(() => {
    if (status && tenderId && housebill) {
      if (status === "rejected") {
        setShowRejectedReasons(true);
      } else {
        updateTender("");
      }
    }
  }, [status, tenderId, housebill]);

  const updateTender = async (reasons: any) => {
    if (status && tenderId && housebill) {
    try {
      await apiService.post(`/AddUpdateTenderDetails`, {
        "tenderId": tenderId,
        "acceptanceStatus": status=== "accepted",
        "housebill": housebill,
        "reasons" : reasons
      }
      );
    } catch (e: any) {
      const errorMessages = getErrorMessageString(e);
      if (errorMessages !== undefined && e?.response?.status !== 401)
        notificationController.error({
          message: "Error",
          description: `Error fetching container types: ${errorMessages}`,
        });
    }
  }
  };


  const handleRejectionSubmit = async (reasons: number[]) => {
    await updateTender(reasons);
    setShowRejectedReasons(false);
  };

  return (
    <Row justify="space-between" style={{ width: "100%" }}>
      <Col span={22} style={{marginLeft: "5%"}}>
        <Row justify="space-between" gutter={24} style={{ width: "100%" }}>
          <Col span={4}>
            <div style={{ width: 115 }}>
              <Image src={LogoIcon} preview={false} alt="logo" />
            </div>
          </Col>
        </Row>
      </Col>
      <Col span={22} style={{marginLeft: "5%"}}>
        <LayoutMaster>
          <LayoutMain>
            <SettingsWrapper>
              <InfoWrapper>
                <div className="flex items-center justify-center min-h-screen bg-gray-100">
                  <div className="p-8 bg-white rounded-lg shadow-md">
                  {showRejectedReasons ? (
                      <RejectedReasons onSubmit={handleRejectionSubmit} />
                    ) : (<h1
                      style={{
                        fontSize: "1.5rem",
                        fontWeight: "bold",
                        marginBottom: "1rem",
                        color: status === "accepted" ? "green" : "red",
                      }}
                    >
                        {status === "accepted"
                          ? "Your tender load has been accepted."
                          : status === "rejected" ? "Your tender load has been rejected." : ""}
                      </h1>
                    )}
                  </div>
                </div>
              </InfoWrapper>
            </SettingsWrapper>
          </LayoutMain>
        </LayoutMaster>
        <MainFooter isTwoColumnsLayout={false}>
          <div className="footer-content">
            &copy; {new Date().getFullYear()} PEGASUS LOGISTICS GROUP. ALL
            RIGHTS RESERVED
          </div>
        </MainFooter>
      </Col>
    </Row>
  );
};

export default TenderPageAcceptance;
